module.exports = __webpack_public_path__ + "img/armory.a7d7cf2e.png";